import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'vendasta-yesware-bridge-api.vendasta-local.com',
  'test': '',
  'demo': 'vendasta-yesware-bridge-demo.apigateway.co',
  'prod': 'vendasta-yesware-bridge-prod.apigateway.co',
  'production': 'vendasta-yesware-bridge-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Account {
  static fromProto(proto) {
    let m = new Account();
    m = Object.assign(m, proto);
    if (proto.accountId) {
      m.accountId = parseInt(proto.accountId, 10);
    }
    if (proto.currentContract) {
      m.currentContract = Contract.fromProto(proto.currentContract);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.currentContract !== 'undefined' && this.currentContract !== null) {
      toReturn['currentContract'] = 'toApiJson' in this.currentContract ? this.currentContract.toApiJson() : this.currentContract;
    }
    if (typeof this.ownerEmail !== 'undefined') {
      toReturn['ownerEmail'] = this.ownerEmail;
    }
    if (typeof this.memberEmails !== 'undefined') {
      toReturn['memberEmails'] = this.memberEmails;
    }
    return toReturn;
  }
}
class Contract {
  static fromProto(proto) {
    let m = new Contract();
    m = Object.assign(m, proto);
    if (proto.availableSeats) {
      m.availableSeats = parseInt(proto.availableSeats, 10);
    }
    if (proto.totalSeats) {
      m.totalSeats = parseInt(proto.totalSeats, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.availableSeats !== 'undefined') {
      toReturn['availableSeats'] = this.availableSeats;
    }
    if (typeof this.totalSeats !== 'undefined') {
      toReturn['totalSeats'] = this.totalSeats;
    }
    return toReturn;
  }
}
class GetAccountRequest {
  static fromProto(proto) {
    let m = new GetAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetAccountResponse {
  static fromProto(proto) {
    let m = new GetAccountResponse();
    m = Object.assign(m, proto);
    if (proto.account) {
      m.account = Account.fromProto(proto.account);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class AddContactToCampaignRequest {
  static fromProto(proto) {
    let m = new AddContactToCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.campaignId) {
      m.campaignId = parseInt(proto.campaignId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
class AddContactToCampaignResponse {
  static fromProto(proto) {
    let m = new AddContactToCampaignResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactCampaignId !== 'undefined') {
      toReturn['contactCampaignId'] = this.contactCampaignId;
    }
    return toReturn;
  }
}
class Campaign {
  static fromProto(proto) {
    let m = new Campaign();
    m = Object.assign(m, proto);
    if (proto.campaignId) {
      m.campaignId = parseInt(proto.campaignId, 10);
    }
    if (proto.stepCount) {
      m.stepCount = parseInt(proto.stepCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.stepCount !== 'undefined') {
      toReturn['stepCount'] = this.stepCount;
    }
    return toReturn;
  }
}
class ListUsersCampaignsRequest {
  static fromProto(proto) {
    let m = new ListUsersCampaignsRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListUsersCampaignsResponse {
  static fromProto(proto) {
    let m = new ListUsersCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(Campaign.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Namespace {
  static fromProto(proto) {
    let m = new Namespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let YeswareAccountsApiService = /*#__PURE__*/(() => {
  class YeswareAccountsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAccount(r) {
      const request = r.toApiJson ? r : new GetAccountRequest(r);
      return this.http.post(this._host + "/vendasta_yesware_bridge.v1.YeswareAccountsService/GetAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountResponse.fromProto(resp)));
    }
  }
  YeswareAccountsApiService.ɵfac = function YeswareAccountsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || YeswareAccountsApiService)();
  };
  YeswareAccountsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: YeswareAccountsApiService,
    factory: YeswareAccountsApiService.ɵfac,
    providedIn: 'root'
  });
  return YeswareAccountsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let YeswareCampaignsApiService = /*#__PURE__*/(() => {
  class YeswareCampaignsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    addContactToCampaign(r) {
      const request = r.toApiJson ? r : new AddContactToCampaignRequest(r);
      return this.http.post(this._host + "/vendasta_yesware_bridge.v1.YeswareCampaignsService/AddContactToCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddContactToCampaignResponse.fromProto(resp)));
    }
    listUsersCampaigns(r) {
      const request = r.toApiJson ? r : new ListUsersCampaignsRequest(r);
      return this.http.post(this._host + "/vendasta_yesware_bridge.v1.YeswareCampaignsService/ListUsersCampaigns", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUsersCampaignsResponse.fromProto(resp)));
    }
  }
  YeswareCampaignsApiService.ɵfac = function YeswareCampaignsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || YeswareCampaignsApiService)();
  };
  YeswareCampaignsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: YeswareCampaignsApiService,
    factory: YeswareCampaignsApiService.ɵfac,
    providedIn: 'root'
  });
  return YeswareCampaignsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Account, AddContactToCampaignRequest, AddContactToCampaignResponse, Campaign, Contract, GetAccountRequest, GetAccountResponse, HostService, ListUsersCampaignsRequest, ListUsersCampaignsResponse, Namespace, PagedRequestOptions, PagedResponseMetadata, YeswareAccountsApiService, YeswareCampaignsApiService };
